/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    rounded: { type: 'variant', values: [ true ] },
    size: { type: 'variant', values: [ 'small' ] }
  },
  rules: [
    {
      if: { size: 'small' },
      tokens: { paddingBottom: 4, paddingTop: 4 }
    },
    { if: { rounded: true }, tokens: { borderRadius: 4 } }
  ],
  tokens: {
    background: '#7a3dfc',
    borderRadius: 0,
    color: '#ffffff',
    gap: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8
  }
}
export default theme
